import 'twin.macro';

import { useEffect } from 'react';
import { Link } from 'react-router-dom';

import iconBook from '../assets/svgs/book.svg';
import iconDiscord from '../assets/svgs/discord.svg';
import iconClose from '../assets/svgs/icon-close.svg';
import iconInstagram from '../assets/svgs/instagram.svg';
import imgLogo from '../assets/svgs/logo.svg';
import iconMenu from '../assets/svgs/menu.svg';
import iconTelegram from '../assets/svgs/telegram.svg';
import iconTiktok from '../assets/svgs/tiktok.svg';
import iconTwitter from '../assets/svgs/twitter.svg';

const navLinks = [
  { label: 'CONTENT', link: 'https://joystickgaming.io/content/' },
  {
    label: 'WHAT IS JOYSTICK',
    link: 'https://joystickgaming.io/what-is-joystick/',
  },
  {
    external: true,
    label: 'LOAN/BORROW',
    link: 'https://apply.joystickgaming.io/',
  },
];

export const social = [
  {
    icon: iconBook,
    title: 'docs',
    url: 'https://whitepaper.joystickgaming.io/',
    width: 23,
  },
  {
    icon: iconTwitter,
    title: 'twitter',
    url: 'https://twitter.com/joystickpros',
    width: 24,
  },
  {
    icon: iconDiscord,
    title: 'discord',
    url: 'https://discord.gg/joystickgaming',
    width: 24,
  },
  {
    icon: iconInstagram,
    title: 'instagram',
    url: 'https://www.instagram.com/joystick/',
    width: 22,
  },
  {
    icon: iconTiktok,
    title: 'tiktok',
    url: 'https://www.tiktok.com/@joystick',
    width: 19,
  },
  {
    icon: iconTelegram,
    title: 'telegram',
    url: 'https://t.me/joystickgaming',
    width: 25,
  },
  // {
  //   icon: iconMedium,
  //   title: 'medium',
  //   url: 'https://joystick-games.medium.com/',
  //   width: 24,
  // },
];

const Header = ({
  menuOpened,
  onToggleMenu,
}: {
  menuOpened: boolean;
  onToggleMenu: () => void;
}) => {
  return (
    <header tw="absolute left-0 top-0 px-10 w-full bg-transparent z-50">
      <div tw="w-full h-[88px] flex justify-between items-center">
        <Link to="https://joystickgaming.io">
          <img alt="logo" src={imgLogo} tw="w-full max-w-[162px]" />
        </Link>
        <div tw="flex items-center gap-[26px]"></div>
        {/* <button tw="block md:hidden" onClick={() => onToggleMenu()}>
          <img alt="menu" src={menuOpened ? iconClose : iconMenu} />
        </button> */}
      </div>
    </header>
  );
};

export default Header;
